import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=167034c2&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167034c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167034c2')) {
      api.createRecord('167034c2', component.options)
    } else {
      api.reload('167034c2', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=167034c2&scoped=true&", function () {
      api.rerender('167034c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22IB2mcVOfTtg/JS/comp/Voucher-Unit.vue"
export default component.exports